// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"31d1634a","290":"e86de3c6","452":"20d1b910","510":"831b6dd0","517":"858f191b","633":"b113812c","677":"e0866fe3","693":"94c86097","972":"e2980245"}[chunkId] + ".chunk.js";
};